import { memo } from 'react'
import { usePress } from '@react-aria/interactions'

import { Icon } from '~/shared/ui/Icon'

import type { BackButtonProps } from './types'

import styles from './BackButton.module.scss'

/**
 * Своя кнопка «назад» для многошаговых флоу и вложенных экранов (спека 01 §7):
 * квадрат 34×34, радиус 12, surface-alt, шеврон 18px.
 * Нативный TG BackButton при этом продолжает работать независимо.
 */
export const BackButton = memo(function BackButton(props: BackButtonProps) {
  const { onPress, isDisabled = false } = props
  const { pressProps, isPressed } = usePress({ onPress, isDisabled })

  return (
    <button
      className={styles.root}
      type='button'
      aria-label='Назад'
      aria-disabled={isDisabled || undefined}
      data-pressed={isPressed}
      {...pressProps}
    >
      <Icon name='chevron-left' size={18} strokeWidth={1.6} />
    </button>
  )
})
